var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "justify-center", attrs: { id: "dossier" } },
    [
      _c("ehr-navigation", { attrs: { "active-item": "dossier" } }),
      _vm._v(" "),
      _c("div", { staticClass: "container", attrs: { id: "dossierWrapper" } }, [
        !_vm.isNewDossier
          ? _c(
              "div",
              { staticClass: "container", attrs: { id: "personalInfo" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "row mb-4",
                    attrs: { id: "personeelslidContent" }
                  },
                  [
                    _c(
                      "dossier-card",
                      {
                        attrs: {
                          "card-title": _vm.labels.personeelslid.objectName,
                          "card-icon": "id-card",
                          isValid: _vm.isValidCard.personeelslid,
                          "is-editable": _vm.isEditing === "none",
                          "is-editing": _vm.isEditing === "personeelslid",
                          "is-loading": !_vm.loaded,
                          hasRequestInProgress: _vm.cardHasChangesInProgress(
                            "personeelslid"
                          )
                        },
                        on: {
                          "cancel-editing": function($event) {
                            return _vm.cancelEditing()
                          },
                          "submit-changes": function($event) {
                            return _vm.submitDossierChanges("personeelslid")
                          },
                          "wijzig-dossier": function($event) {
                            return _vm.editCard("personeelslid")
                          }
                        }
                      },
                      [
                        _vm.loaded
                          ? _c("div", [
                              _vm.isEditing !== "personeelslid"
                                ? _c(
                                    "div",
                                    [
                                      _c("personeelslid-view", {
                                        attrs: {
                                          personeelslid: _vm.personeelslid,
                                          "hidden-fields-map":
                                            _vm.hiddenFieldsMap.personeelslid
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("h5", [_vm._v("Aanvragen")]),
                                      _vm._v(" "),
                                      !_vm.personeelslidChanges.length
                                        ? _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-center text-secondary"
                                            },
                                            [
                                              _vm._v(
                                                "U heeft geen wijzigingen aangevraagd."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.changesLoaded
                                        ? _c(
                                            "div",
                                            _vm._l(
                                              _vm.personeelslidChanges,
                                              function(wijziging, index) {
                                                return _c(
                                                  "dossier-collapse",
                                                  {
                                                    key: index,
                                                    attrs: {
                                                      "can-submit": _vm.canSubmitAdditionsFor(
                                                        "personeelslid"
                                                      ),
                                                      "can-cancel":
                                                        wijziging.steps
                                                          .length === 1,
                                                      status:
                                                        wijziging.requestStatus,
                                                      date: wijziging.created,
                                                      "is-open":
                                                        index === 0 &&
                                                        wijziging.requestStatus !==
                                                          "accepted"
                                                    },
                                                    on: {
                                                      "collapse-cancel": function(
                                                        $event
                                                      ) {
                                                        return _vm.cancelChReqStep(
                                                          wijziging
                                                        )
                                                      },
                                                      "collapse-submit": function(
                                                        $event
                                                      ) {
                                                        return _vm.submitChReqAddition(
                                                          wijziging,
                                                          "personeelslid"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "changes-list",
                                                      {
                                                        attrs: {
                                                          "card-name":
                                                            "personeelslid",
                                                          wijziging: wijziging
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "label",
                                                          {
                                                            staticClass:
                                                              "font-weight-bold",
                                                            attrs: {
                                                              for:
                                                                "DossierOpmerkingInput"
                                                            }
                                                          },
                                                          [_vm._v("Opmerking:")]
                                                        ),
                                                        _vm._v(" "),
                                                        _c("textarea", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm
                                                                  .dossierAdditionRemarks
                                                                  .personeelslid,
                                                              expression:
                                                                "dossierAdditionRemarks.personeelslid"
                                                            }
                                                          ],
                                                          staticClass:
                                                            "form-control mb-2",
                                                          attrs: {
                                                            id:
                                                              "DossierOpmerkingInput",
                                                            rows: "3",
                                                            placeholder:
                                                              "Opmerking",
                                                            type: "text"
                                                          },
                                                          domProps: {
                                                            value:
                                                              _vm
                                                                .dossierAdditionRemarks
                                                                .personeelslid
                                                          },
                                                          on: {
                                                            input: function(
                                                              $event
                                                            ) {
                                                              if (
                                                                $event.target
                                                                  .composing
                                                              ) {
                                                                return
                                                              }
                                                              _vm.$set(
                                                                _vm.dossierAdditionRemarks,
                                                                "personeelslid",
                                                                $event.target
                                                                  .value
                                                              )
                                                            }
                                                          }
                                                        }),
                                                        _vm._v(" "),
                                                        _c("file-upload", {
                                                          attrs: {
                                                            label:
                                                              " Bestanden of bewijsstukken toevoegen:",
                                                            "upload-percentage": 0
                                                          },
                                                          on: {
                                                            "files-changed": function(
                                                              $event
                                                            ) {
                                                              return _vm.onAdditionFilesChanged(
                                                                $event,
                                                                "personeelslid"
                                                              )
                                                            }
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "spinner-border text-primary",
                                                  attrs: { role: "status" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr-only" },
                                                    [
                                                      _vm._v(
                                                        "Aanvragen worden geladen..."
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm.isEditing === "personeelslid"
                                ? _c(
                                    "div",
                                    [
                                      _c("personeelslid-form", {
                                        attrs: {
                                          personeelslid: _vm.personeelslid,
                                          cache: _vm.cache.personeelslid,
                                          remark: _vm.remarks.personeelslid,
                                          "disabled-fields-map":
                                            _vm.disabledFieldsMap.personeelslid,
                                          "hidden-fields-map":
                                            _vm.hiddenFieldsMap.personeelslid,
                                          "proof-required-fields-map":
                                            _vm.proofRequiredFieldsMap
                                              .personeelslid,
                                          warningFieldsMap:
                                            _vm.warningFieldsMap.personeelslid,
                                          "proof-info-fields-map":
                                            _vm.proofInfoFieldsMap.personeelslid
                                        },
                                        on: {
                                          "validation-change": function(
                                            $event
                                          ) {
                                            return _vm.onValidationChange(
                                              $event,
                                              "personeelslid"
                                            )
                                          },
                                          "remark-changed": function($event) {
                                            return _vm.onRemarkChanged(
                                              $event,
                                              "personeelslid"
                                            )
                                          },
                                          "files-changed": function($event) {
                                            return _vm.onFilesChanged(
                                              $event,
                                              "personeelslid"
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "row mb-4", attrs: { id: "contactContent" } },
                  [
                    _c(
                      "dossier-card",
                      {
                        attrs: {
                          "card-title": _vm.labels.contact.objectName,
                          "card-icon": "phone",
                          isValid: _vm.isValidCard.contact,
                          "is-editable": _vm.isEditing === "none",
                          "is-editing": _vm.isEditing === "contact",
                          "is-loading": !_vm.loaded,
                          hasRequestInProgress: _vm.cardHasChangesInProgress(
                            "contact"
                          )
                        },
                        on: {
                          "cancel-editing": function($event) {
                            return _vm.cancelEditing("contact")
                          },
                          "submit-changes": function($event) {
                            return _vm.submitDossierChanges("contact")
                          },
                          "wijzig-dossier": function($event) {
                            return _vm.editCard("contact")
                          }
                        }
                      },
                      [
                        _vm.loaded
                          ? _c("div", [
                              _vm.isEditing !== "contact"
                                ? _c(
                                    "div",
                                    [
                                      _c("contact-view", {
                                        attrs: { contact: _vm.contact }
                                      }),
                                      _vm._v(" "),
                                      _c("h5", [_vm._v("Aanvragen")]),
                                      _vm._v(" "),
                                      !_vm.contactChanges.length
                                        ? _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-center text-secondary"
                                            },
                                            [
                                              _vm._v(
                                                "U heeft geen wijzigingen aangevraagd."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.changesLoaded
                                        ? _c(
                                            "div",
                                            _vm._l(_vm.contactChanges, function(
                                              wijziging,
                                              index
                                            ) {
                                              return _c(
                                                "dossier-collapse",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "dossier-collapse",
                                                  attrs: {
                                                    "can-submit": _vm.canSubmitAdditionsFor(
                                                      "contact"
                                                    ),
                                                    "can-cancel":
                                                      wijziging.steps.length ===
                                                      1,
                                                    date: wijziging.created,
                                                    status:
                                                      wijziging.requestStatus,
                                                    "is-open":
                                                      index === 0 &&
                                                      wijziging.requestStatus !==
                                                        "accepted"
                                                  },
                                                  on: {
                                                    "collapse-cancel": function(
                                                      $event
                                                    ) {
                                                      return _vm.cancelChReqStep(
                                                        wijziging
                                                      )
                                                    },
                                                    "collapse-submit": function(
                                                      $event
                                                    ) {
                                                      return _vm.submitChReqAddition(
                                                        wijziging,
                                                        "contact"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "changes-list",
                                                    {
                                                      attrs: {
                                                        "card-name": "contact",
                                                        wijziging: wijziging
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                          attrs: {
                                                            for:
                                                              "DossierOpmerkingInput"
                                                          }
                                                        },
                                                        [_vm._v("Opmerking:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .dossierAdditionRemarks
                                                                .contact,
                                                            expression:
                                                              "dossierAdditionRemarks.contact"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control mb-2",
                                                        attrs: {
                                                          id:
                                                            "DossierOpmerkingInput",
                                                          rows: "3",
                                                          placeholder:
                                                            "Opmerking",
                                                          type: "text"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm
                                                              .dossierAdditionRemarks
                                                              .contact
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.dossierAdditionRemarks,
                                                              "contact",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("file-upload", {
                                                        attrs: {
                                                          label:
                                                            " Bestanden of bewijsstukken toevoegen:",
                                                          "upload-percentage": 0
                                                        },
                                                        on: {
                                                          "files-changed": function(
                                                            $event
                                                          ) {
                                                            return _vm.onAdditionFilesChanged(
                                                              $event,
                                                              "contact"
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "spinner-border text-primary",
                                                  attrs: { role: "status" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr-only" },
                                                    [
                                                      _vm._v(
                                                        "Aanvragen worden geladen..."
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm.isEditing === "contact"
                                ? _c(
                                    "div",
                                    [
                                      _c("contact-form", {
                                        attrs: {
                                          contact: _vm.contact,
                                          cache: _vm.cache.contact,
                                          remark: _vm.remarks.contact,
                                          "disabled-fields-map":
                                            _vm.disabledFieldsMap.contact,
                                          "proof-required-fields-map":
                                            _vm.proofRequiredFieldsMap.contact,
                                          "proof-info-fields-map":
                                            _vm.proofInfoFieldsMap.contact
                                        },
                                        on: {
                                          "validation-change": function(
                                            $event
                                          ) {
                                            return _vm.onValidationChange(
                                              $event,
                                              "contact"
                                            )
                                          },
                                          "remark-changed": function($event) {
                                            return _vm.onRemarkChanged(
                                              $event,
                                              "contact"
                                            )
                                          },
                                          "files-changed": function($event) {
                                            return _vm.onFilesChanged(
                                              $event,
                                              "contact"
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row content mb-4",
                    attrs: { id: "gezinstoestandContent" }
                  },
                  [
                    _c(
                      "dossier-card",
                      {
                        attrs: {
                          "card-title": _vm.labels.gezin.objectName,
                          isValid: _vm.isValidCard.gezin,
                          "card-icon": "user-friends",
                          "is-editable": _vm.isEditing === "none",
                          "is-editing": _vm.isEditing === "gezin",
                          "is-loading": !_vm.loaded,
                          hasRequestInProgress: _vm.cardHasChangesInProgress(
                            "gezin"
                          )
                        },
                        on: {
                          "cancel-editing": function($event) {
                            return _vm.cancelEditing("gezin")
                          },
                          "submit-changes": function($event) {
                            return _vm.submitDossierChanges("gezin")
                          },
                          "wijzig-dossier": function($event) {
                            return _vm.editCard("gezin")
                          }
                        }
                      },
                      [
                        _vm.loaded
                          ? _c("div", [
                              _vm.isEditing !== "gezin"
                                ? _c(
                                    "div",
                                    [
                                      _c("gezin-view", {
                                        attrs: {
                                          gezin: _vm.gezin,
                                          "hidden-fields-map":
                                            _vm.hiddenFieldsMap.gezin
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("h5", [_vm._v("Aanvragen")]),
                                      _vm._v(" "),
                                      !_vm.gezinChanges.length
                                        ? _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-center text-secondary"
                                            },
                                            [
                                              _vm._v(
                                                "U heeft geen wijzigingen aangevraagd."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.changesLoaded
                                        ? _c(
                                            "div",
                                            _vm._l(_vm.gezinChanges, function(
                                              wijziging,
                                              index
                                            ) {
                                              return _c(
                                                "dossier-collapse",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    "can-submit": _vm.canSubmitAdditionsFor(
                                                      "gezin"
                                                    ),
                                                    "can-cancel":
                                                      wijziging.steps.length ===
                                                      1,
                                                    date: wijziging.created,
                                                    status:
                                                      wijziging.requestStatus,
                                                    "is-open":
                                                      index === 0 &&
                                                      wijziging.requestStatus !==
                                                        "accepted"
                                                  },
                                                  on: {
                                                    "collapse-cancel": function(
                                                      $event
                                                    ) {
                                                      return _vm.cancelChReqStep(
                                                        wijziging
                                                      )
                                                    },
                                                    "collapse-submit": function(
                                                      $event
                                                    ) {
                                                      return _vm.submitChReqAddition(
                                                        wijziging,
                                                        "gezin"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "changes-list",
                                                    {
                                                      attrs: {
                                                        "card-name": "gezin",
                                                        wijziging: wijziging
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                          attrs: {
                                                            for:
                                                              "DossierOpmerkingInput"
                                                          }
                                                        },
                                                        [_vm._v("Opmerking:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .dossierAdditionRemarks
                                                                .gezin,
                                                            expression:
                                                              "dossierAdditionRemarks.gezin"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control mb-2",
                                                        attrs: {
                                                          id:
                                                            "DossierOpmerkingInput",
                                                          rows: "3",
                                                          placeholder:
                                                            "Opmerking",
                                                          type: "text"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm
                                                              .dossierAdditionRemarks
                                                              .gezin
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.dossierAdditionRemarks,
                                                              "gezin",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("file-upload", {
                                                        attrs: {
                                                          label:
                                                            " Bestanden of bewijsstukken toevoegen:",
                                                          "upload-percentage": 0
                                                        },
                                                        on: {
                                                          "files-changed": function(
                                                            $event
                                                          ) {
                                                            return _vm.onAdditionFilesChanged(
                                                              $event,
                                                              "gezin"
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "spinner-border text-primary",
                                                  attrs: { role: "status" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr-only" },
                                                    [
                                                      _vm._v(
                                                        "Aanvragen worden geladen..."
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isEditing === "gezin"
                                ? _c(
                                    "div",
                                    [
                                      _c("gezin-form", {
                                        attrs: {
                                          gezin: _vm.gezin,
                                          cache: _vm.cache.gezin,
                                          remark: _vm.remarks.gezin,
                                          "disabled-fields-map":
                                            _vm.disabledFieldsMap.gezin,
                                          "hidden-fields-map":
                                            _vm.hiddenFieldsMap.gezin,
                                          "proof-required-fields-map":
                                            _vm.proofRequiredFieldsMap.gezin,
                                          "proof-info-fields-map":
                                            _vm.proofInfoFieldsMap.gezin
                                        },
                                        on: {
                                          "validation-change": function(
                                            $event
                                          ) {
                                            return _vm.onValidationChange(
                                              $event,
                                              "gezin"
                                            )
                                          },
                                          "remark-changed": function($event) {
                                            return _vm.onRemarkChanged(
                                              $event,
                                              "gezin"
                                            )
                                          },
                                          "files-changed": function($event) {
                                            return _vm.onFilesChanged(
                                              $event,
                                              "gezin"
                                            )
                                          },
                                          "update-partner": _vm.onUpdatePartner
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "row content mb-4",
                    attrs: { id: "OverigeContent" }
                  },
                  [
                    _c(
                      "dossier-card",
                      {
                        attrs: {
                          "card-icon": "ellipsis-h",
                          isValid: _vm.isValidCard.overige,
                          "card-title": _vm.labels.overige.objectName,
                          "is-editable": _vm.isEditing === "none",
                          "is-editing": _vm.isEditing === "overige",
                          "is-loading": !_vm.loaded,
                          hasRequestInProgress: _vm.cardHasChangesInProgress(
                            "overige"
                          )
                        },
                        on: {
                          "cancel-editing": function($event) {
                            return _vm.cancelEditing("overige")
                          },
                          "submit-changes": function($event) {
                            return _vm.submitDossierChanges("overige")
                          },
                          "wijzig-dossier": function($event) {
                            return _vm.editCard("overige")
                          }
                        }
                      },
                      [
                        _vm.loaded
                          ? _c("div", [
                              _vm.isEditing !== "overige"
                                ? _c(
                                    "div",
                                    [
                                      _c("overige-view", {
                                        attrs: {
                                          overige: _vm.overige,
                                          "hidden-fields-map":
                                            _vm.hiddenFieldsMap.overige
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("h5", [_vm._v("Aanvragen")]),
                                      _vm._v(" "),
                                      !_vm.overigeChanges.length
                                        ? _c(
                                            "small",
                                            {
                                              staticClass:
                                                "text-center text-secondary"
                                            },
                                            [
                                              _vm._v(
                                                "U heeft geen wijzigingen aangevraagd."
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.changesLoaded
                                        ? _c(
                                            "div",
                                            _vm._l(_vm.overigeChanges, function(
                                              wijziging,
                                              index
                                            ) {
                                              return _c(
                                                "dossier-collapse",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    "can-submit": _vm.canSubmitAdditionsFor(
                                                      "overige"
                                                    ),
                                                    "can-cancel":
                                                      wijziging.steps.length ===
                                                      1,
                                                    status:
                                                      wijziging.requestStatus,
                                                    date: wijziging.created,
                                                    "is-open":
                                                      index === 0 &&
                                                      wijziging.requestStatus !==
                                                        "accepted"
                                                  },
                                                  on: {
                                                    "collapse-cancel": function(
                                                      $event
                                                    ) {
                                                      return _vm.cancelChReqStep(
                                                        wijziging
                                                      )
                                                    },
                                                    "collapse-submit": function(
                                                      $event
                                                    ) {
                                                      return _vm.submitChReqAddition(
                                                        wijziging,
                                                        "overige"
                                                      )
                                                    }
                                                  }
                                                },
                                                [
                                                  _c(
                                                    "changes-list",
                                                    {
                                                      attrs: {
                                                        cardName: "overige",
                                                        wijziging: wijziging
                                                      }
                                                    },
                                                    [
                                                      _c(
                                                        "label",
                                                        {
                                                          staticClass:
                                                            "font-weight-bold",
                                                          attrs: {
                                                            for:
                                                              "DossierOpmerkingInput"
                                                          }
                                                        },
                                                        [_vm._v("Opmerking:")]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("textarea", {
                                                        directives: [
                                                          {
                                                            name: "model",
                                                            rawName: "v-model",
                                                            value:
                                                              _vm
                                                                .dossierAdditionRemarks
                                                                .overige,
                                                            expression:
                                                              "dossierAdditionRemarks.overige"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "form-control mb-2",
                                                        attrs: {
                                                          id:
                                                            "DossierOpmerkingInput",
                                                          rows: "3",
                                                          placeholder:
                                                            "Opmerking",
                                                          type: "text"
                                                        },
                                                        domProps: {
                                                          value:
                                                            _vm
                                                              .dossierAdditionRemarks
                                                              .overige
                                                        },
                                                        on: {
                                                          input: function(
                                                            $event
                                                          ) {
                                                            if (
                                                              $event.target
                                                                .composing
                                                            ) {
                                                              return
                                                            }
                                                            _vm.$set(
                                                              _vm.dossierAdditionRemarks,
                                                              "overige",
                                                              $event.target
                                                                .value
                                                            )
                                                          }
                                                        }
                                                      }),
                                                      _vm._v(" "),
                                                      _c("file-upload", {
                                                        attrs: {
                                                          label:
                                                            " Bestanden of bewijsstukken toevoegen:",
                                                          "upload-percentage": 0
                                                        },
                                                        on: {
                                                          "files-changed": function(
                                                            $event
                                                          ) {
                                                            return _vm.onAdditionFilesChanged(
                                                              $event,
                                                              "overige"
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            }),
                                            1
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "d-flex justify-content-center"
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "spinner-border text-primary",
                                                  attrs: { role: "status" }
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "sr-only" },
                                                    [
                                                      _vm._v(
                                                        "Aanvragen worden geladen..."
                                                      )
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                    ],
                                    1
                                  )
                                : _vm.isEditing === "overige"
                                ? _c(
                                    "div",
                                    [
                                      _c("overige-form", {
                                        attrs: {
                                          overige: _vm.overige,
                                          cache: _vm.cache.overige,
                                          remark: _vm.remarks.overige,
                                          "disabled-fields-map":
                                            _vm.disabledFieldsMap.overige,
                                          "hidden-fields-map":
                                            _vm.hiddenFieldsMap.overige,
                                          "proof-required-fields-map":
                                            _vm.proofRequiredFieldsMap.overige,
                                          "proof-info-fields-map":
                                            _vm.proofInfoFieldsMap.overige
                                        },
                                        on: {
                                          "validation-change": function(
                                            $event
                                          ) {
                                            return _vm.onValidationChange(
                                              $event,
                                              "overige"
                                            )
                                          },
                                          "remark-changed": function($event) {
                                            return _vm.onRemarkChanged(
                                              $event,
                                              "overige"
                                            )
                                          },
                                          "files-changed": function($event) {
                                            return _vm.onFilesChanged(
                                              $event,
                                              "overige"
                                            )
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]
            )
          : _c(
              "div",
              { staticClass: "container", attrs: { id: "personalInfo" } },
              [
                _c(
                  "div",
                  {
                    staticClass: "row mb-4",
                    attrs: { id: "newDossierContent" }
                  },
                  [
                    _c(
                      "dossier-card",
                      {
                        attrs: {
                          "card-title":
                            "Gelieve eerst uw gegevens te controleren en/of aan te vullen.",
                          "card-icon": "folder-open",
                          isValid: true,
                          "is-editable": false,
                          "is-loading": !_vm.loaded,
                          "has-top-buttons": false
                        }
                      },
                      [
                        _vm.loaded
                          ? _c(
                              "div",
                              [
                                _c(
                                  "ehr-stepper",
                                  {
                                    attrs: {
                                      steps: _vm.steps,
                                      "can-continue": _vm.isValidForm,
                                      "is-form-changed":
                                        _vm.isDossierFormUpdated
                                    },
                                    on: {
                                      "active-step-changed":
                                        _vm.updateActiveStep,
                                      "stepper-finished": _vm.finishStepper,
                                      "cancel-stepper": _vm.cancelStepper
                                    }
                                  },
                                  [
                                    _vm.activeStep === 0
                                      ? _c("personeelslid-form", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            personeelslid: _vm.personeelslid,
                                            remark: _vm.remarks.personeelslid,
                                            attachments:
                                              _vm.attachments.personeelslid,
                                            "is-new": true,
                                            cache: _vm.cache.personeelslid,
                                            warningFieldsMap:
                                              _vm.warningFieldsMap
                                                .personeelslid,
                                            "is-in-wizard": true,
                                            "disabled-fields-map":
                                              _vm.disabledFieldsMap
                                                .personeelslid,
                                            "hidden-fields-map":
                                              _vm.hiddenFieldsMap.personeelslid,
                                            "proof-required-fields-map":
                                              _vm.proofRequiredFieldsMap
                                                .personeelslid,
                                            "proof-info-fields-map":
                                              _vm.proofInfoFieldsMap
                                                .personeelslid
                                          },
                                          on: {
                                            "validation-change": function(
                                              $event
                                            ) {
                                              return _vm.onValidationChange(
                                                $event,
                                                "personeelslid"
                                              )
                                            },
                                            "remark-changed": function($event) {
                                              return _vm.onRemarkChanged(
                                                $event,
                                                "personeelslid"
                                              )
                                            },
                                            "files-changed": function($event) {
                                              return _vm.onFilesChanged(
                                                $event,
                                                "personeelslid"
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.activeStep === 1
                                      ? _c("contact-form", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            contact: _vm.contact,
                                            cache: _vm.cache.contact,
                                            remark: _vm.remarks.contact,
                                            attachments:
                                              _vm.attachments.contact,
                                            "is-new": true,
                                            "disabled-fields-map":
                                              _vm.disabledFieldsMap.contact,
                                            "proof-required-fields-map":
                                              _vm.proofRequiredFieldsMap
                                                .contact,
                                            "proof-info-fields-map":
                                              _vm.proofInfoFieldsMap.contact
                                          },
                                          on: {
                                            "validation-change": function(
                                              $event
                                            ) {
                                              return _vm.onValidationChange(
                                                $event,
                                                "contact"
                                              )
                                            },
                                            "remark-changed": function($event) {
                                              return _vm.onRemarkChanged(
                                                $event,
                                                "contact"
                                              )
                                            },
                                            "files-changed": function($event) {
                                              return _vm.onFilesChanged(
                                                $event,
                                                "contact"
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.activeStep === 2
                                      ? _c("gezin-form", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            gezin: _vm.gezin,
                                            cache: _vm.cache.gezin,
                                            attachments: _vm.attachments.gezin,
                                            remark: _vm.remarks.gezin,
                                            "is-new": true,
                                            "disabled-fields-map":
                                              _vm.disabledFieldsMap.gezin,
                                            "hidden-fields-map":
                                              _vm.hiddenFieldsMap.gezin,
                                            "proof-required-fields-map":
                                              _vm.proofRequiredFieldsMap.gezin,
                                            "proof-info-fields-map":
                                              _vm.proofInfoFieldsMap.gezin
                                          },
                                          on: {
                                            "validation-change": function(
                                              $event
                                            ) {
                                              return _vm.onValidationChange(
                                                $event,
                                                "gezin"
                                              )
                                            },
                                            "remark-changed": function($event) {
                                              return _vm.onRemarkChanged(
                                                $event,
                                                "gezin"
                                              )
                                            },
                                            "files-changed": function($event) {
                                              return _vm.onFilesChanged(
                                                $event,
                                                "gezin"
                                              )
                                            },
                                            "update-partner":
                                              _vm.onUpdatePartner
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.activeStep === 3
                                      ? _c("overige-form", {
                                          staticClass: "mt-4",
                                          attrs: {
                                            overige: _vm.overige,
                                            cache: _vm.cache.overige,
                                            attachments:
                                              _vm.attachments.overige,
                                            remark: _vm.remarks.overige,
                                            "is-new": true,
                                            "disabled-fields-map":
                                              _vm.disabledFieldsMap.overige,
                                            "hidden-fields-map":
                                              _vm.hiddenFieldsMap.overige,
                                            "proof-required-fields-map":
                                              _vm.proofRequiredFieldsMap
                                                .overige,
                                            "proof-info-fields-map":
                                              _vm.proofInfoFieldsMap.overige
                                          },
                                          on: {
                                            "validation-change": function(
                                              $event
                                            ) {
                                              return _vm.onValidationChange(
                                                $event,
                                                "overige"
                                              )
                                            },
                                            "remark-changed": function($event) {
                                              return _vm.onRemarkChanged(
                                                $event,
                                                "overige"
                                              )
                                            },
                                            "files-changed": function($event) {
                                              return _vm.onFilesChanged(
                                                $event,
                                                "overige"
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e()
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              ]
            )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }